import { render, staticRenderFns } from "./TsCheckbox.vue?vue&type=template&id=2ac51a1e"
import script from "./TsCheckbox.vue?vue&type=script&lang=js"
export * from "./TsCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports